import React from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  TextInputProps,
} from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface FloatingLabelInputProps extends Omit<TextInputProps, 'style'> {
  label: string;
  value: string;
  error?: string;
  containerStyle?: object;
}

/**
 * Reusable input component with floating label
 * Used in credit card and ACH forms
 */
export const FloatingLabelInput: React.FC<FloatingLabelInputProps> = ({
  label,
  value,
  error,
  containerStyle,
  ...textInputProps
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();
  const hasValue = value.length > 0;

  return (
    <View style={[styles.inputWrapper, containerStyle]}>
      <View style={styles.inputWithLabel}>
        {hasValue && (
          <Text style={[styles.inputLabel, { color: MARKETPLACE_COLORS.textSecondary }]}>{label}</Text>
        )}
        <TextInput
          style={[
            styles.input,
            { backgroundColor: MARKETPLACE_COLORS.inputBackground, borderColor: MARKETPLACE_COLORS.inputBorder, color: MARKETPLACE_COLORS.textPrimary },
            hasValue && styles.inputWithValue,
            error && { borderColor: MARKETPLACE_COLORS.accentRed },
          ]}
          value={value}
          placeholder={label}
          placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
          autoComplete="off"
          {...textInputProps}
        />
      </View>
      {error && (
        <Text style={[styles.errorText, { color: MARKETPLACE_COLORS.accentRed }]}>{error}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  inputWrapper: {
    marginBottom: 4,
  },
  inputWithLabel: {
    position: 'relative',
  },
  inputLabel: {
    position: 'absolute',
    top: 4,
    left: 16,
    fontSize: 10,
    fontWeight: '600',
    lineHeight: 12.5,
    zIndex: 1,
  },
  input: {
    height: 40,
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    fontSize: 14,
    fontWeight: '400',
  },
  inputWithValue: {
    paddingTop: 14,
    paddingBottom: 4,
  },
  errorText: {
    fontSize: 12,
    fontWeight: '400',
    marginTop: 4,
  },
});

export default FloatingLabelInput;
